import { analyticService } from 'global/services';

export const dispatchPageviewEvent = () => {
    analyticService.push({ eventName: 'Pageview', pagePath: 'romantic', pageUrl: window.location.href });
};
